const getUniqueKey = () => new Date().getTime().toString(36);

export {
	getUniqueKey,
};
